<template>
  <div style="position: relative; min-height: 600px" :style="{ height: 'calc(' + this.windowHeight + ' - 0px)' }">
    <div class="login-top d-column">
      <!-- <div class="status_bar"></div> -->
      <img src="@/assets/img/appointment/logo.png" />
      <!-- <img class="login-bg" src="@/static/img/loginbg.png" width="100vw" mode="aspectFill" /> -->
      <!-- <img class="bg-bottom" src="@/static/img/bgbottom.svg" /> -->
      <!-- <img v-if="!currSchoolLogo" class="school-logo" src="@/static/logo.svg" /> -->
      <!-- <img v-else class="school-logo" :src="currSchoolLogo" /> -->
      <div class="fs-xl system-ch">校外人员场馆预约</div>
    </div>
    <div class="input-form">
      <!-- <u-notify ref="uNotify" message="暂无网络连接,请检查"></u-notify> -->

      <div class="input-each">
        <div class="fs-sm grey input-name">姓名</div>
        <input class="b-bottom my-input" placeholder="请输入姓名" v-model="loginName" />
      </div>
      <div class="input-each">
        <div class="fs-sm grey input-name">手机号</div>
        <input class="b-bottom my-input" placeholder="请输入手机号" v-model="loginPhone" />
      </div>
      <!-- <div class="error-msg fs-sm" >{{ errorMsg }}</div> -->
      <!-- <button class="my-btn login-btn fs-lg custom-style" @click="redirectToAuth">获取</button> -->
      <button class="my-btn login-btn fs-lg custom-style" @click="saveInfoFir">保&nbsp;存</button>
      <div style="margin-bottom: 100px">
        <div class="d-aligncnter d-between">
          <div class="btn-msg fs-sm"><span style="color: red">*</span><span>此页面仅为校外人员场馆预约使用</span></div>
        </div>
      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="80%" :show-close="false">
      <div class="d-aligncnter d-column">
        <img src="@/assets/img/appointment/success.svg" />
        <span style="margin-top: 8px">系统后续将以此手机号联系用户</span>
      </div>

      <div slot="footer" class="dialog-footer d-allcenter" style="width: 100%">
        <el-button type="primary" @click="saveUserHandle" class="register-btn" round>知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { get } from '../../api/http'
// import { post } from '../../api/http'
import { requestUser, saveUser } from '@/api/api-venueOrder'
import { Message } from 'element-ui'
export default {
  data() {
    return {
      inputType: 'password',
      errorMsg: '',
      ifError: false,
      //   currEye: require('@/static/img/eye-close.svg'),
      loginName: '',
      loginPhone: '',
      status: '',
      backButtonPress: 0,
      windowHeight: '100vh',
      disLogin: false,
      loginLoading: false,
      loginText: '',
      noNetShow: true,
      systemInfo: {},
      setGrey: false,
      mustCheck: false,
      currSchool: '',
      checkbox: [],
      schoolList: [],
      authorityShow: false,
      currSchoolLogo: '',
      dialogVisible: false,
      currOpenId: '',
      accessToken: '',
      testdata: '',
      postData: {
        touser: 'OPENID',
        template_id: 'ck4_N17qvPgIpOMhwKe39jtTbo3ccP5SZ5lNse9dP0I',
        url: 'http://weixin.qq.com/download',
        miniprogram: {
          //跳小程序
          //   appid: 'wxb4c490a00a0736ee',
          //   pagepath: 'appointment/inforegist',
        },
        client_msg_id: 'MSG_000001',
        data: {
          short_thing2: {
            value: '预约成功',
          },
          thing3: {
            value: '风雨操场',
          },
          time8: {
            value: '2024-01-02',
          },
          time4: {
            value: '2024-01-04',
          },
        },
      },
    }
  },
  created() {},
  mounted() {
    // this.redirectToAuth()
    // this.hasOpenId()
    this.getAuthorize()
  },
  methods: {
    redirectToAuth() {
      const appid = 'wxb4c490a00a0736ee'
      //   const redirect_uri = encodeURIComponent('https://ty.hzcu.edu.cn/appointment/inforegist')
      const redirect_uri = encodeURIComponent('http://ty.ngrok.hzwolf.com/appointment/inforegist')
      const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect` // 静默授权
      //   const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      window.location.href = authUrl
    },
    getAuthorize() {
      const openId = localStorage.getItem('openId')
      console.log('openId::', openId)
      if (openId) {
        this.hasOpenId()
      } else {
        const code = new URLSearchParams(window.location.search).get('code')
        this.testdata = code
        console.log('code:', code)
        if (code) {
          //   const appid = 'wx291996a71c63b9dd'
          const appid = 'wxb4c490a00a0736ee'
          const secret = '469682a6e2e32bb7c8074fcdcaa03d5d'
          // const requestUrl = `https://api.weixin.qq.com/sns/oauth2/access_token?appid=${appid}&secret=YOUR_APP_SECRET&code=${code}&grant_type=authorization_code`
          const requestUrl = `/api/sns/oauth2/access_token?appid=${appid}&secret=${secret}&code=${code}&grant_type=authorization_code`
          console.log('requestUrl:', requestUrl)
          get(requestUrl).then((res) => {
            console.log('res:', res)
            // this.testdata = res
            if (res && res.data.openid) {
              this.currOpenId = res.data.openid
              this.accessToken = res.data.access_token
              console.log('yes?', this.currOpenId)
              console.log('accessToken?', this.accessToken)
              localStorage.setItem('openId', this.currOpenId)
              localStorage.setItem('accessToken', this.accessToken)
              this.postData.touser = this.currOpenId
              this.hasOpenId()
            }
          })
        } else {
          this.redirectToAuth()
        }
      }
    },
    hasOpenId() {
      // 获取模板列表and发送模板信息
      //   const appid = 'wxb4c490a00a0736ee'
      //   const secret = '469682a6e2e32bb7c8074fcdcaa03d5d'
      //   const tokenUrl = `/api/cgi-bin/token?grant_type=client_credential&appid=${appid}&secret=${secret}`
      //   get(tokenUrl).then((res) => {
      //     console.log('res:', res)
      //     if (res && res.data.access_token) {
      //       //   const requestUrl = `/api/cgi-bin/template/get_industry?access_token=${res.data.access_token}` //获取行业
      //       const requestUrl = `/api/cgi-bin/template/get_all_private_template?access_token=${res.data.access_token}` //获取模板列表
      //       get(requestUrl).then((res) => {
      //         console.log('res:', res)
      //       })
      //       const tempUrl = `/api/cgi-bin/message/template/send?access_token=${res.data.access_token}`//发送模板消息
      //       post(tempUrl, this.postData).then((res) => {
      //         console.log('res:', res)
      //       })
      //     }
      //   })

      const open = localStorage.getItem('openId')
      requestUser(open).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res')
          localStorage.setItem('userId', res.data.obj.userId)
          this.$router.push({ path: '/appointment/index' })
        } else {
          this.saveUserHandle()
        }
      })
    },
    // getTemp() {
    //   const requestUrl = `/api/cgi-bin/template/get_all_private_template?access_token=${res.data.access_token}`
    //   get(requestUrl).then((res) => {
    //     console.log('res:', res)
    //   })
    // },
    saveInfoFir() {
      if (!this.loginName || !this.loginPhone) {
        Message.error('请先填写姓名和手机号！')
      } else {
        this.dialogVisible = true
      }
    },
    saveUserHandle() {
      const opne = localStorage.getItem('openId')
      saveUser(this.loginName, this.loginPhone, opne).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res')
          localStorage.setItem('userId', res.data.obj.userId)
          this.$router.push({ path: '/appointment/index' })
          this.dialogVisible = false
        } else {
          this.dialogVisible = false
          Message.error(res.data.message)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.login-top {
  width: 100%;
  height: 240px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('../../assets/img/appointment/loginbg.svg') no-repeat;
  background-size: cover;
  .login-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  .school-logo {
    width: 72px;
    height: 72px;
    margin-top: 100rpx;
  }
}
.system-ch {
  color: #fff;
  margin-top: 16px;
  text-shadow: 1px 0px 1px rgba(1, 81, 51, 0.5);
}
.system-en {
  margin-top: 4px;
  font-size: 12px;
  transform: scale(0.9);
  white-space: nowrap;
  color: #fff;
  text-shadow: 1px 0px 1px rgba(1, 81, 51, 0.5);
}
.register-top {
  width: 100%;
  height: 320rpx;
  position: relative;
  display: flex;
  align-items: center;
  .register-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
  }
  .system-ch {
    margin-top: 120rpx;
  }
  .back {
    position: absolute;
    top: 0;
    left: 0;
    width: 50px;
    height: 50px;
    img {
      width: 24px;
      height: 24px;
      margin-left: 16px;
      margin-top: 16px;
    }
  }
}
.bg-bottom {
  position: absolute;
  width: calc(100% + 2px);
  bottom: -1px;
  left: -1px;
  right: -1px;
  display: none;
}

.my-input {
  width: 100%;
  border: none;
  border-bottom: 1px solid #d1d1d1;
  outline: none;
  height: 40px;
  text-indent: 12px;
  margin-top: 4px;
}
.input-form {
  width: calc(100% - 32px);
  margin-left: 16px;
  .input-each {
    width: 100%;
    margin-top: 24px;
    position: relative;
  }
}
.input-name {
  width: 100%;
  text-align: left;
}
.eyes {
  position: absolute;
  right: 12px;
  top: 31px;
  width: 24px;
  height: 24px;
}
.error-msg {
  color: #de3831;
  margin-top: 16px;
  text-indent: 12px;
}
.my-btn {
  //   width: 343px;
  width: 100%;
  height: 56px;
  border: none;
  border-radius: 52px;
  color: #fff;
  line-height: 56px;
}
.btn-msg {
  color: #8b8b8b;
  margin-top: 8px;
}
.msg-check {
  color: #8b8b8b;
  margin-top: 25px;
  display: flex;
  align-items: center;
  checkbox {
    margin-right: 4px;
    margin-top: 2px;
    transform: scale(0.7);
  }
}
.login-btn {
  background: linear-gradient(270deg, #007a4d 0%, #1a875f 100%);
  margin-top: 16px;
  line-height: 56px;
}
.register-btn {
  background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%), linear-gradient(270deg, #007a4d 0%, #1a875f 100%);
  border: none;
  height: 36px;
}
.find-pwd {
  color: #04764e;
}

.custom-style {
  font-size: 18px;
}

.ifgrey {
  filter: grayscale(100%);
}

.unablebtn {
  margin-top: 16px;
  line-height: 56px;
  background: #888;
}
</style>
